import { makeServerPut, makeServerPost, makeServerRequest, makeServerDelete} from './util';

const apiPrefix = "api/v1/servers";

export function fetchServersSuccess(servers) {
    return {
        type: "FETCH_SERVERS_SUCCESS",
        payload: servers
    };
}

export function fetchServersFailure(error) {
    return {
        type: "FETCH_SERVERS_FAILURE",
        payload: error
    };
}

export const newServer = () => {
    return {
        type: 'NEW_SERVER'
    };
}

export const clearServer = () => {
    return {
        type: 'CLEAR_SERVER'
    };
}

export const fetchServers = (countryCode) => {
    return (dispatch) => {
        dispatch({type: "FETCH_SERVERS"});

        let callString = apiPrefix;
        if (countryCode) {
            console.log(countryCode);
            callString += "?countryCode=" + countryCode;
        }

        return makeServerRequest(callString).then(
            response => dispatch(fetchServersSuccess(response.data))
        ).catch(
            error => {
                dispatch(fetchServersFailure(error))
                throw error
            }
        );
    };
};

export function fetchServerSuccess(server) {
    return {
        type: "FETCH_SERVER_SUCCESS",
        payload: server
    };
}

export function fetchServerFailure(error) {
    return {
        type: "FETCH_SERVER_FAILURE",
        payload: error
    };
}

export const fetchServer = (id) => {
    return (dispatch) => {
        dispatch({type: "FETCH_SERVER"});

        return makeServerRequest(apiPrefix + "/" + id).then(
            response => dispatch(fetchServerSuccess(response.data))
        ).catch(
            error => {
                dispatch(fetchServerFailure(error))
                throw error
            }
        );
    };
};

export function persistServerSuccess(server) {
    return {
        type: "PERSIST_SERVER_SUCCESS",
        payload: server,
        successMessage: 'Server saved'
    };
}

export function persistServerFailure(error) {
    return {
        type: "PERSIST_SERVER_FAILURE",
        payload: error,
        errorMessage: error
    };
}

export const persistServer = (server) => {

    return (dispatch) => {
        dispatch({type: "PERSIST_SERVER"});

        if(!server.id) {  //If there isn't any ID then we make an POST 
            return makeServerPost(apiPrefix + "/", server).then (
                response => dispatch(persistServerSuccess(response.data))
            ).catch(
                error => dispatch(persistServerFailure(error.response.data.errorCode))
            );
        } else {
            return makeServerPut(apiPrefix + "/" + server.id, server).then(
                response => dispatch(persistServerSuccess(response.data))
            ).catch(
                error => dispatch(persistServerFailure(error.response.data.errorCode))
            );
        }
    };
};

export const deleteServerSuccess = (server) => {
    return {
        type: "DELETE_SERVER_SUCCESS",
        payload: server
    };
};

export const deleteServerFailure = (error) => {
    return {
        type: "DELETE_SERVER_FAILURE",
        payload: error
    };
};

export const deleteServer = (serverId) => {
    return (dispatch) => {
        dispatch({type: "DELETE_SERVER", payload: serverId});

        return makeServerDelete(apiPrefix + "/" + serverId).then(
            response => dispatch(deleteServerSuccess(response.data))
        ).catch(
            error => dispatch(deleteServerFailure(error))
        );
    };
};

export function syncServerSuccess(result, id) {
    return {
        type: "SYNC_SERVER_SUCCESS",
        payload: result,
        successMessage: "Custom synchronization started for server " + id
    };
}

export function syncServerFailure(error, id) {
    return {
        type: "SYNC_SERVER_FAILURE",
        payload: error,
        errorMessage: error + " (Server " + id + ")"
    };
}

export const syncServer = (id, params = {startTime: '2018-02-20 12:00:00', endTime: '2018-02-28 13:00:00'}) => {
    return (dispatch) => {
        dispatch({type: "SYNC_SERVER"});

        return makeServerPost(apiPrefix + "/" + id + "/synchronize", params).then(
            response => dispatch(syncServerSuccess(response.data, id))
        ).catch(
            error => dispatch(syncServerFailure(error.response.data.errorCode, id))
        );
    };
};






// WEBPACK FOOTER //
// ./src/store/actions/servers.js